// IMPORTS
// schema
import * as ISchema from "@schema";

import { commitMutation } from "react-relay";
import { Environment } from "relay-runtime";
import { recordImpressionMutation } from "./RecordImpression.gql";
import { modernCache } from "@network/modern-network-layer";
import { identifyExperiment } from "@util/analytics.util";
import { isOn, ExperimentNameType } from "@util/experiment.util";

// TYPES
interface IRecordImpressionMutationResponse {
  recordImpression: ISchema.IRecordImpressionMutationPayload;
}

// MUTATION
export function recordImpression(
  environment: Environment,
  org: ISchema.IOrg | null,
  experiment: ExperimentNameType,
  onSuccess: (response?: ISchema.IRecordImpressionMutationPayload) => void,
  onError: (error?: any) => void,
  override?: boolean,
) {
  // generate the mutation input
  const enabled = isOn(org, experiment) || override;
  const input: ISchema.IRecordImpressionMutationInput = {
    name: experiment,
    treatmentType: !!enabled ? "On" : "Off",
  };

  // identify tracking
  identifyExperiment(org, experiment);

  // commit
  commitMutation(environment, {
    onError,
    mutation: recordImpressionMutation,
    variables: { input },
    onCompleted: (response: IRecordImpressionMutationResponse, errors?: Error[]) => {
      if (!!errors) {
        onError(errors[0]);
      } else {
        // if we're not in a modern environment, modernCache will be undefined
        if (modernCache) {
          modernCache.clear();
        }
        onSuccess(response.recordImpression);
      }
    },
  });
}
